import React, { useContext } from 'react';
import c from 'classnames';
import { CommentEditorContext } from '../../../CommentEditor.editor_v3/context';
import s from './CommentBoxContentWrapper.scss';
/**
 * Standard styling for the content of our comment box.
 * Also adds the global editor class we need for themeing inside of DaEditor
 */ const CommentBoxContentWrapper = ({ children, className })=>{
    const { isExpanded } = useContext(CommentEditorContext);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['commentbox-content'], 'da-editor-comment', isExpanded && s['expanded'], className)
    }, children);
};
CommentBoxContentWrapper.displayName = 'CommentBoxContentWrapper';
export default CommentBoxContentWrapper;

//# sourceMappingURL=CommentBoxContentWrapper.js.map